module.exports = __webpack_public_path__ + "static/media/bug.051bbc30.svg";